import template from './newsList.html';
import controller from './newsList.controller';
import './newsList.scss';

let newsListComponent = {
  restrict: 'E',
  // bindings injected by resolve
  bindings: {
    news: '<',
    navigation: '<',
  },
  template,
  controller
};

export default newsListComponent;



// WEBPACK FOOTER //
// ./client/app/components/apps/newsList/newsList.component.js